<template>
  <v-card>

    <v-card-title class="headline green lighten-2">
      Call Detail
    </v-card-title>

    <v-card-text>
      <v-layout row wrap>

        <!-- <v-flex xs4 grey--text my-2>
          Call ID
        </v-flex>
        <v-flex xs8 my-2>
          {{ item.uniqueid }}
        </v-flex>

        <v-flex xs4 grey--text my-2>
          Timestamp
        </v-flex>
        <v-flex xs8 my-2>
          {{ item.timestamp }}
        </v-flex> -->

        <template v-for="row in rows">
          <v-flex xs4 grey--text my-2>{{ row.label }}</v-flex>
          <v-flex xs8 my-2>{{ item[row.idx] }}</v-flex>
        </template>

      </v-layout>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <!-- <audio src="/getvoicelog/{{ item.uniqueid }}"></audio> -->
      <!-- <v-btn small flat icon color="primary" @click="playVoicelog">
        <v-icon>play_arrow</v-icon>
      </v-btn> -->
      <v-btn small flat icon color="primary" @click="downloadVoicelog" :loading="loadingVoicelog" v-if="item.hasvoicelog">
        <v-icon>save_alt</v-icon>
      </v-btn>
      <div class="caption font-italic red--text mx-2">
        {{ downloadError }}
      </div>
      <v-spacer></v-spacer>
      <v-btn color="primary" flat @click="closeDialog">
        Close
      </v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
export default {
  name: 'calldetail',
  props: {
    item: {
      // type: Object,
      required: true
    }
  },
  data: () => ({
    rows: [
      { 'idx': 'uniqueid', 'label': 'Call ID' },
      { 'idx': 'timestamp', 'label': 'Timestamp'},
      { 'idx': 'source', 'label': 'Source'},
      { 'idx': 'destination', 'label': 'Destination' },
      { 'idx': 'calltype', 'label': 'Call type'}
    ],
    loadingVoicelog: false,
    downloadError: ''
  }),
  sockets: {
    voicelog_data: function (vldata) {
      console.log('got voicelog data packet')
      let blob = new Blob([vldata], { 'type': 'audio/wav' })
      console.log(blob)
      var audio = document.createElement('audio')
      audio.type = 'audio/wav'
      audio.src = window.URL.createObjectURL(blob)
      audio.play()
    }
  },
  methods: {
    closeDialog: function () {
      this.$emit('closeDialog')
    },
    playVoicelog: function () {
      this.$socket.emit('stream_voicelog',this.item.uniqueid)
    },
    downloadVoicelog:  function () {
      this.loadingVoicelog = true
      this.$api.get('/getvoicelog/' + this.item.uniqueid,{ responseType: 'arraybuffer' }).then(response => {
        this.loadingVoicelog = false

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download','voicelog.wav')
        document.body.appendChild(link)
        link.click()
      }).catch(e => {
        this.loadingVoicelog = false
        if (!e.response) {
          this.downloadError = 'No response from API server'
        } else {
          this.downloadError = 'Error retrieving voicelog (error ' + e.response.status + ')'
        }
      })
    }
  },
  watch: {
    item: function () {
      this.downloadError = ''
    }
  }
}
</script>

<style scoped>
</style>
